import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getRequest } from "../Masters/baseservice";
import { BASE_URL, getAxiosConfig } from "../../components/interface/Config";
import { apiHandler } from "../../services/authService";

// Define the structure for the API response
interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

interface ProviderInfo {
  id: number;
  user_id: number;
  hospital_id: number;
  group_id: number;
  practicing_since: string;
  license_no: string;
  additional_info: {
    qualification: string[];
  };
  availabilities: {
    tz: string;
    day: boolean;
    text: string;
    timing: {
      slot: any[];
      queue: { from_time: string; to_time: string }[];
    };
  }[];
  created_at: string;
  updated_at: string;
}

const Masters: React.FC = () => {
  const navigate = useNavigate();

  // State to store provider information
  const [providerInfo, setProviderInfo] = useState<ProviderInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);


  // Fetch provider information on component mount
  useEffect(() => {
    const fetchProviderInfo = async () => {
      try {
        console.log("Fetching provider info...");
        setLoading(true);

        const url         = `${BASE_URL}/users/providerinfo?user_id=undefined`;
        const response1   = await apiHandler('', 'GET', {}, url);

        if (response1?.data) {
          console.log("Fetched Provider Data:", response1.data);
          setProviderInfo(response1.data.data);
        } else {
          console.warn("No data found in the response.");
        }
        console.log("response1",response1?.data);

        // const response = await fetch(
        //   `https://telegaruda-api.a2zhealth.in/v1/users/providerinfo?user_id=undefined`,
        //   {
        //     method: 'GET',
        //     headers: { ...getAxiosConfig().headers },
        //   }
        // );

        // if (!response.ok) {
        //   throw new Error(`HTTP error! status: ${response.status}`);
        // }

        // const data = await response.json();
        // console.log("Response received:", data);

        // if (data?.data) {
        //   console.log("Fetched Provider Data:", data.data);
        //   setProviderInfo(data.data);
        // } else {
        //   console.warn("No data found in the response.");
        // }
      } catch (error) {
        console.error("Error fetching provider info:", error);
      } finally {
        setLoading(false);
        console.log("Loading state set to false.");
      }
    };

    fetchProviderInfo();
  }, []);



  const iconMap: { [key: string]: string } = {
    "Allergy": "🌱",
    "Allergy Reaction": "⚡",
    "Medication (Generic)": "💊",
    "Medication (Brand)": "🧴",
    "Symptoms": "🤕",
    "Condition": "🩺",
    "ICD 10": "📚",
    "Lab": "🔬",
    "Imaging": "🖥️",
    "Procedure": "📝",
    "Medication (Sig Info)": "📑",
  };

  const cardItems = [
    { title: "Allergy", subtitle: "Manage Allergy" },
    { title: "Allergy Reaction", subtitle: "Manage Allergy Reaction" },
    { title: "Medication (Generic)", subtitle: "Manage Medivation (Generic)" },
    { title: "Medication (Brand)", subtitle: "Manage Medication (Brand)" },
    { title: "Medication (Sig Info)", subtitle: "Manage Medication (Sig Info)" },
    { title: "Symptoms", subtitle: "Manage Symptoms" },
    { title: "Condition", subtitle: "Manage Condition" },
    { title: "ICD 10", subtitle: "Manage ICD 10 codes" },
    { title: "Lab", subtitle: "Manage Lab Tests" },
    { title: "Imaging", subtitle: "Manage Imaging" },
    { title: "Procedure", subtitle: "Manage Procedure Codes" },
  ];

  const handleCardClick = (title: string) => {
    console.log(" title:", title);
    const formattedTitle = title.toLowerCase().replace(/[^a-z0-9]/g, '');
    console.log("Formatted title:", formattedTitle);
    const providerId = providerInfo?.id;
    const userid = providerInfo?.user_id;
    if (providerId) {
      navigate(`/home/masters/${formattedTitle}-masters`, { state: { providerId, userid } });
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full bg-[#eaeaea]">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="font-primary bg-white flex justify-center mt-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-12 max-w-screen">
        {cardItems.map((item, index) => (
          <div
            key={index}
            className="w-[355px] border rounded-3xl p-4 shadow-md bg-white flex flex-col justify-between items-center text-center transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer"
            onClick={() => handleCardClick(item.title)}
          >
            <div className="text-4xl mb-2">{iconMap[item.title]}</div>
            <h2 className="text-[#0B6BAD] font-bold text-xl mb-1">{item.title}</h2>
            <p className="text-gray-600 text-sm">{item.subtitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Masters;
